if (!customElements.get('quick-add-modal')) {
  customElements.define(
    'quick-add-modal',
    class QuickAddModal extends ModalDialog {
      constructor() {
        super();
        this.modalContent = this.querySelector('[id^="QuickAddInfo-"]');

        this.addEventListener('product-info:loaded', ({ target }) => {
          target.addPreProcessCallback(this.preprocessHTML.bind(this));
        });

        document.addEventListener('click', (event) => {
          const target = event.target;
          if (target && target.matches('.modal-overlay')) {
            this.hide(false);
          }
        });
      }

      hide(preventFocus = false) {
        const cartNotification = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        const isQuickAddEdit = this.classList.contains('pd-quick-add-modal--edit');
        if (cartNotification) cartNotification.setActiveElement(this.openedBy);
        setTimeout(() => {
          this.modalContent.innerHTML = '';
          if (preventFocus) this.openedBy = null;
          if (isQuickAddEdit) {
          document.body.classList.remove('opening-edit-drawer');
        }
        }, 400);

        super.hide(isQuickAddEdit);
      }

      show(opener, itemData) {
        opener.setAttribute('aria-disabled', true);
        opener.classList.add('loading');
        opener.querySelector('.loading__spinner').classList.remove('hidden');
        const parsedItemData = JSON.parse(itemData) || null;

        fetch(opener.getAttribute('data-product-url'))
          .then((response) => response.text())
          .then((responseText) => {
            const responseHTML = new DOMParser().parseFromString(responseText, 'text/html');
            const productElement = responseHTML.querySelector('product-info');

            this.preprocessHTML(productElement);
            HTMLUpdateUtility.setInnerHTML(this.modalContent, productElement.outerHTML);

            if (parsedItemData?.key) {
              this.querySelector('.product-form__submit')?.setAttribute('data-item-key', parsedItemData?.key);
            }

            if (parsedItemData?.quantity) {
              this.querySelector('.product-form__submit')?.setAttribute('data-item-quantity', parsedItemData?.quantity);
            }

            if (parsedItemData?.variantId) {
              const ELM_selected = this.querySelector(`[data-variant-id='${parsedItemData?.variantId}']`);
              if (!ELM_selected) return;
              if (this.querySelector('.product-variant-selector__item-selector__header-label')) {
                this.querySelector('.product-variant-selector__item-selector__header-label').innerHTML = ELM_selected?.getAttribute('data-variant-value');
              }
              ELM_selected.closest('.product-variant-selector__item-dropdown')?.classList.add('is-selected');
              if (!this.querySelector('.product-variant-selector__item-dropdown:not(.is-selected)')) {
                if (!ELM_selected.hasAttribute('disabled')) {
                  this.querySelector('.product-form__submit')?.removeAttribute('disabled');
                }
                this.querySelector('.product__preorder-message')?.classList.remove('hidden');
              }
            }

            if (window.Shopify && Shopify.PaymentButton) {
              Shopify.PaymentButton.init();
            }
            if (window.ProductModel) window.ProductModel.loadShopifyXR();

            super.show(opener);
          })
          .finally(() => {
            opener.removeAttribute('aria-disabled');
            opener.classList.remove('loading');
            opener.querySelector('.loading__spinner').classList.add('hidden');
            if (parsedItemData) {
              document.body.classList.add('opening-edit-drawer');
            }
          });
      }

      preprocessHTML(productElement) {
        // productElement.classList.forEach((classApplied) => {
        //   if (classApplied.startsWith('color-') || classApplied === 'gradient')
        //     this.modalContent.classList.add(classApplied);
        // });
        this.preventDuplicatedIDs(productElement);
        this.removeDOMElements(productElement);
        this.removeGalleryListSemantic(productElement);
        this.updateImageSizes(productElement);
        this.preventVariantURLSwitching(productElement);
        this.unwrapQuickAddGallery(productElement);
      }

      // quick-add-gallery ships template-wrapped so its images stay inert on
      // the full PDP; the drawer is the only place it renders live.
      unwrapQuickAddGallery(productElement) {
        productElement.querySelectorAll('template[data-quick-add-gallery]').forEach((tpl) => {
          tpl.replaceWith(tpl.content.cloneNode(true));
        });
      }

      preventVariantURLSwitching(productElement) {
        productElement.setAttribute('data-update-url', 'false');
      }

      removeDOMElements(productElement) {
        const pickupAvailability = productElement.querySelector('pickup-availability');
        if (pickupAvailability) pickupAvailability.remove();

        const productModal = productElement.querySelector('product-modal');
        if (productModal) productModal.remove();

        const modalDialog = productElement.querySelectorAll('modal-dialog');
        if (modalDialog) modalDialog.forEach((modal) => modal.remove());
      }

      preventDuplicatedIDs(productElement) {
        const sectionId = productElement?.dataset.section;

        const oldId = sectionId;
        const newId = `quickadd-${sectionId}`;
        productElement.innerHTML = productElement.innerHTML.replaceAll(oldId, newId);
        Array.from(productElement.attributes).forEach((attribute) => {
          if (attribute.value.includes(oldId)) {
            productElement.setAttribute(attribute.name, attribute.value.replace(oldId, newId));
          }
        });

        productElement.dataset.originalSection = sectionId;
      }

      removeGalleryListSemantic(productElement) {
        const galleryList = productElement.querySelector('[id^="Slider-Gallery"]');
        if (!galleryList) return;

        galleryList.setAttribute('role', 'presentation');
        galleryList.querySelectorAll('[id^="Slide-"]').forEach((li) => li.setAttribute('role', 'presentation'));
      }

      updateImageSizes(productElement) {
        const product = productElement.querySelector('.product');
        const desktopColumns = product?.classList.contains('product--columns');
        if (!desktopColumns) return;

        const mediaImages = product.querySelectorAll('.product__media img');
        if (!mediaImages.length) return;

        let mediaImageSizes =
          '(min-width: 1000px) 715px, (min-width: 750px) calc((100vw - 11.5rem) / 2), calc(100vw - 4rem)';

        if (product.classList.contains('product--medium')) {
          mediaImageSizes = mediaImageSizes.replace('715px', '605px');
        } else if (product.classList.contains('product--small')) {
          mediaImageSizes = mediaImageSizes.replace('715px', '495px');
        }

        mediaImages.forEach((img) => img.setAttribute('sizes', mediaImageSizes));
      }
    }
  );
}
